import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-delete-product-confirmation-dialog',
  templateUrl: './delete-product-confirmation-dialog.component.html',
  styleUrls: ['./delete-product-confirmation-dialog.component.scss']
})
export class DeleteProductConfirmationDialogComponent implements OnInit {

  text: string;
  
  constructor(
    public dialogRef: MatDialogRef<string>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {
    this.text = data ? `Sei sicuro di voler rimuovere definitivamente ${data}` : 'Sei sicuro di voler rimuovere definitivamente il prodotto selezionato?';
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

}
